<div class="layout-wrapper layout-content-navbar" style="background-color: #F8F8FF;">
  <div class="layout-container">
    <div class="container-xxl flex-grow-1 container-p-y">
      <div class="page-heading">
                   <h1 class="page-title mb-0 ">Build ECRF</h1>
                   <button class="btn custom-button"   style="margin-left: 10px; margin-top: -10px;" [routerLink]="['/ecrf-list']">
          Go to ECRF List
        </button>
                   
          </div>
        <p class="page-subtitle">Create and manage your ECRF Templates</p>
        <!-- 👉 ADD this container here 👈 -->
      
      <div class="row">
        <!-- Side Nav for Templates -->
        <div class="col-12">
          <button class="menu-btn" (click)="toggleSideNav()">&#9776;</button>
          <div class="layout-wrapper layout-content-navbar" style="background-color: #F8F8FF;">
          <div class="sidebar-card">
            <aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme" [ngClass]="{'show-nav': isSidebarVisible}">
              <div class="menu-inner-shadow"></div>
              <div class="menu-item">
                <div class="px-6 py-2 border-bottom d-flex justify-content-between align-items-center w-100">
                  <h5 class="folder-heading mb-0">ECRF Templates</h5>
                </div>

                <div class="p-3 border-bottom">
                  <div class="input-group input-group-sm">
                    <input
                      id="templateName"
                      type="text"
                      class="form-control"
                      [(ngModel)]="newTemplateName"
                      placeholder="New template name"
                      (keyup.enter)="createNewTemplate()"
                    />
                    <button class="btn btn-primary" (click)="createNewTemplate()" [disabled]="!newTemplateName.trim()" style="background-color: #3b1e61 !important;">
                      <i class="bx bx-plus"></i>
                    </button>
                  </div>
                  <small class="text-muted mt-2 d-block">
                    <i class="bx bx-info-circle me-1"></i>
                    New templates will include default clinical trial folders and forms
                  </small>
                </div>

                <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height: 150px;">
                  <div class="spinner-border text-purple" role="status">
                    <span class="visually-hidden">creating template...</span>
                  </div>
                </div>

                <!-- Templates list in side nav -->
                <div *ngIf="!loading">
                  <ul class="list-group list-group-flush">
                    <li
                      class="list-group-item border-0 d-flex justify-content-between align-items-center template-item"
                      *ngFor="let template of ecrfTemplates"
                      (click)="openTemplate(template)"
                    >
                      <div class="d-flex align-items-center w-100">
                        <i class="menu-icon tf-icons bx bx-layout me-2"></i>
                        <ng-container *ngIf="editingTemplateId !== template.id; else editTpl">
                          <span class="text-truncate">{{ template.name }}</span>
                        </ng-container>
                        <ng-template #editTpl>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            [(ngModel)]="editedTemplateName"
                            (click)="$event.stopPropagation()"
                            (keyup.enter)="saveEditTemplate(template, $event)"
                          />
                        </ng-template>
                      </div>

                    
                      <div class="btn-group btn-group-sm ms-2" (click)="$event.stopPropagation()">
                        <button class="btn btn-outline-secondary" *ngIf="editingTemplateId !== template.id" (click)="startEditTemplate(template, $event)" title="Edit">
                          <i class="bx bx-pencil"></i>
                        </button>
                        <button class="btn btn-outline-danger" *ngIf="editingTemplateId !== template.id" (click)="deleteTemplate(template)" title="Delete">
                          <i class="bx bx-trash"></i>
                        </button>
                        <button class="btn btn-outline-secondary" *ngIf="editingTemplateId === template.id" (click)="saveEditTemplate(template, $event)" [disabled]="!editedTemplateName.trim()" title="Save">
                          <i class="bx bx-check"></i>
                        </button>
                        <button class="btn btn-outline-secondary" *ngIf="editingTemplateId === template.id" (click)="cancelEdit($event)" title="Cancel">
                          <i class="bx bx-x"></i>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- Empty state inline -->
                <div class="text-center py-4" *ngIf="ecrfTemplates.length === 0 && !loading">
                  <i class="bx bx-folder-open display-6 text-muted"></i>
                  <div class="text-muted small">No templates yet</div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>